import { Trip } from '@/typing/api/tripNew.class';
import Role from '@/typing/enums/role.enum';
import { TripStatus } from '@/typing/enums/tripStatus.enum';

export function isTripEditable(trip: Trip, userRole: Role): boolean {
    if (
        (userRole === Role.Client && trip.status === TripStatus.OpenClient) ||
        (userRole === Role.Client && trip.status === TripStatus.ApprovedClient)
    ) {
        return true;
    } else if (
        userRole === Role.Contractor &&
        (trip.status === TripStatus.OpenContractor ||
            trip.status === TripStatus.RejectedClient)
    ) {
        return true;
    } else if (
        userRole === Role.Skipper &&
        (trip.status === TripStatus.OpenSkipper ||
            trip.status === TripStatus.RejectedContractor)
    ) {
        return true;
    }

    return false;
}
